import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import api from "../lib/api";
import { ChairCard } from "../components/ChairCard";

export default function MovementProfile() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { window.scrollTo(0, 0); api.get(`/movements/${slug}`).then((r) => setData(r.data)).catch(() => {}); }, [slug]);
  if (!data) return <div className="py-40 text-center text-muted-foreground">Loading…</div>;
  const { movement, chairs } = data;

  return (
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-6">
      <Link to="/movements" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-accent mb-8"><ChevronLeft size={16} /> Movements</Link>
      <div className="max-w-3xl">
        <p className="overline text-accent">{movement.period}</p>
        <h1 className="serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-2" data-testid="movement-name">{movement.name}</h1>
        <p className="text-lg text-muted-foreground mt-5 leading-relaxed">{movement.summary}</p>
      </div>
      <h2 className="serif text-3xl mt-16 mb-8">Chairs in this movement</h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-10">
        {chairs.map((c, i) => <ChairCard key={c.slug} chair={c} index={i} />)}
      </div>
    </div>
  );
}
